import React, {useEffect, useState} from 'react';
import * as ValgTypes from '../Store/Valg/Types';
import { StamdataUtlandHelgradModel } from '../Models/StamdataUtlandHelgradModel';
import * as UtregningUtland from '../Utilities/Utregning'
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface UtregningAProps {
    tittelUtregning: JSX.Element | null,
    satser: StamdataUtlandHelgradModel | null,
    valg: ValgTypes.ValgState,
    valutaBenevnelseUtregning: string,
    beskrivelseLanFb: JSX.Element | null,
    overskriftLanFb: JSX.Element | null,
    tekstForLanOgStipendSomAlleFaar: JSX.Element | null,
    resTekstAlleOgRekruttering: JSX.Element | null;
    vilkarStudieStotteLenkeTekst: JSX.Element | null,
    vilkarStudieStotteTittel: JSX.Element | null,
    vilkarStudieStotteTekst: JSX.Element | null,
    vilkarLukkStudieStottePopupAriaTekst: string,
    visUtbetalingsPlanHandler: any,
    utbetalingsPlanLenkeTekst: JSX.Element | null,
    locale: string,
    eventId: string | null,
}

export default function UtregningA(props: UtregningAProps): JSX.Element {
    const [visVilkarBModal, setVisVilkarBModal] = useState(false);
    const [visUtbetalingsplan, setVisUtbetalingsplan] = useState(false);

    function onVilkarBClick(): void {
        setVisVilkarBModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarBModal(false);
    }
    useEffect(() => {
        updateLiveMessage();
    }, []);

    function onVisUtbetalingsPlan(): void {
        if(visUtbetalingsplan) {
            setVisUtbetalingsplan(false);
            props.visUtbetalingsPlanHandler(false);
        } else {
            setVisUtbetalingsplan(true);
            props.visUtbetalingsPlanHandler(true);
        }
    }

    const erTildeltRekrutteringsstipend: boolean = UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser) > 0;

    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                        {props.tittelUtregning}
                    </h3>
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst">
                        <span>{UtregningUtland.formatNumber(
                            UtregningUtland.regnUtBasisLan(props.valg, props.satser).totaltStipendOgLan + 
                            UtregningUtland.regnUtReiseStotte(props.valg, props.satser).totaltStipendOgLan +
                            UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser), props.locale)}</span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valutaBenevnelseUtregning}</span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                    {erTildeltRekrutteringsstipend ? (
                        <span>{props.resTekstAlleOgRekruttering}</span>
                    ) : (
                        <span>{props.tekstForLanOgStipendSomAlleFaar}</span>
                    )}
                    </p>
                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder__panel-row-top-space c-veileder__panel-row-bottom-space">
                <div className="c-veileder__content c-veileder__content--header"></div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{props.overskriftLanFb}</div>
                    <div className="c-veileder__underresultat-tekst">
                        <span>{UtregningUtland.formatNumber(UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).totaltStipendOgLan, props.locale)}</span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valutaBenevnelseUtregning}</span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                        <span>{props.beskrivelseLanFb}</span>
                    </p>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onVilkarBClick}>
                        {props.vilkarStudieStotteLenkeTekst}
                    </button>
                    <ModalCompontent
                        isOpen={visVilkarBModal}
                        onRequestClose={onRequestLukkVilkarA}
                        ariaCloseText={props.vilkarLukkStudieStottePopupAriaTekst}
                        eventId={props.eventId}
                    >
                        <ArticleContentComponent
                            headerinnhold={props.vilkarStudieStotteTittel}
                            contentinnhold={props.vilkarStudieStotteTekst}
                        />
                    </ModalCompontent>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--icon-after c-knapp--pil-opp-hvit" onClick={onVisUtbetalingsPlan}>{props.utbetalingsPlanLenkeTekst}</button>
                </div>
            </div>
        </div>
    )

}